<template>
  <div class="collect">
    <div class="banner">
      <img src="@/assets/futurestar2026/banner.jpg">
    </div>

    <div class="content">
       <h3 style="color: rgb(234, 83, 6);">参与条件</h3>

  <h3 style="color: rgb(0, 0, 0); font-size: 14px;">未来之星</h3>

  <ul>
    <li>参与企业为独立法人，注册地位于中国；</li>

    <li>参与企业创立时间在2年以上10年以内；</li>

    <li>参与企业未成为过“未来之星”；</li>

    <li>参与企业未公开上市；</li>

    <li>参与企业具有创新性及高成长性，以下指标中至少满足两项：</li>
    

    <li style="list-style: none; display: inline">
      <p>• 估值在50亿元人民币以上；</p>

      <p>• 融资轮次达到B轮及以上；</p>

      <p>• 近三年营收或用户等核心指标年均增长率不低于10%；</p>

      <p>• 细分市场占有率或核心指标居行业前三名；</p>
    </li>

    <li>参与企业市场认可度高，社会形象良好。</li>
  </ul>

  

  <p style="color: rgb(234, 83, 6);font-size:14px">征集截止日期：2026年6月15日 18:00</p>

  <p style="color: rgb(234, 83, 6);font-size:14px">联系方式：郭女士 15321157997（同微信）</p>
   </div>

  

      <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="auto">
       <div class="el-card box-card is-always-shadow">
        <div class="clearfix header_them">A、公司概况</div>
        <div class="clearfix el-card__body">
        <el-form-item prop="companyShortName">
          <label for="" class="el-form-item-label">
            <span class="xing">*</span>
            <span class="span-box">A1</span> 
            <span>公司简称</span>
          </label>
          <el-input v-model="form.companyShortName" placeholder="" :disabled="isActivityEnded" />
        </el-form-item>
        <el-form-item prop="companyFullName">
          <label for="" class="el-form-item-label">
            <span class="xing">*</span>
            <span class="span-box">A2</span> 
            <span>公司全称</span>
          </label>
          <el-input v-model="form.companyFullName" placeholder="" :disabled="isActivityEnded" />
        </el-form-item>
        <el-form-item prop="foundingTime">
           <label for="" class="el-form-item-label">
            <span class="xing">*</span>
            <span class="span-box">A3</span> 
            <span>成立时间</span>
          </label>
          <el-input v-model="form.foundingTime" placeholder="" :disabled="isActivityEnded" />
        </el-form-item>
        <el-form-item prop="headquarters">
          <label for="sample_name" class="el-form-item-label">
           <span class="xing">*</span>
            <span class="span-box">A4</span> 
            <span>总部注册地</span>
          </label>
          <el-input v-model="form.headquarters" placeholder="" :disabled="isActivityEnded" />
        </el-form-item>
        <el-form-item prop="industry">
          <label for="sample_name" class="el-form-item-label">
            <span class="xing">*</span>
            <span class="span-box">A5</span> 
            <span>所属行业</span>
          </label>
          <el-input v-model="form.industry" placeholder="" :disabled="isActivityEnded" />
        </el-form-item>
        <el-form-item prop="productInMarket">
          <label for="sample_name" class="el-form-item-label">
        
            <span class="span-box">A6</span> 
            <span>公司主营产品（服务）是否已经进入市场</span>
          </label>
          <el-radio-group v-model="form.productInMarket" :disabled="isActivityEnded">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
  </div>
  <div class="el-card box-card is-always-shadow">
        <div class="clearfix header_them">B、财务&融资情况</div>
        <div class="clearfix el-card__body">
        <el-form-item prop="revenueGrowth">
           <label for="sample_name" class="el-form-item-label">
         
            <span class="span-box">B1</span> 
            <span>营收年均增长率（近三年/近两年）</span>
          </label>
          <el-input v-model="form.revenueGrowth" placeholder="" :disabled="isActivityEnded" />
        </el-form-item>
        <el-form-item prop="valuation">
          <label for="sample_name" class="el-form-item-label">
            <span class="xing">*</span>
            <span class="span-box">B2</span> 
            <span>目前估值（人民币）</span>
          </label>
          <el-input v-model="form.valuation" placeholder="" :disabled="isActivityEnded" />
        </el-form-item>
        <el-form-item prop="financingRound">
          <label for="sample_name" class="el-form-item-label">
            <span class="xing">*</span>
            <span class="span-box">B3</span> 
            <span>最新融资轮次</span>
          </label>
          <textarea v-model="form.financingRound" autocomplete="off" rows="3" class="el-textarea__inner" style="min-height: 33px;" :disabled="isActivityEnded"></textarea>
        
        </el-form-item>
        <el-form-item prop="totalFinancing">
          <label for="sample_name" class="el-form-item-label">
            <span class="span-box">B4</span> 
            <span>创立以来的融资总额（人民币）</span>
            </label>
          <el-input v-model="form.totalFinancing" placeholder="" :disabled="isActivityEnded" />
        </el-form-item>
        <el-form-item prop="investors">
            <label for="sample_name" class="el-form-item-label">
              <span class="xing">*</span>
              <span class="span-box">B5</span> 
              <span>主要投资方（列举3家）</span>
              </label>
          <textarea v-model="form.investors" autocomplete="off" rows="3" class="el-textarea__inner" style="min-height: 33px;" :disabled="isActivityEnded"></textarea>
        </el-form-item>
        </div></div>
     <div class="el-card box-card is-always-shadow">
        <div class="clearfix header_them">C、创始人</div>
        <div class="clearfix el-card__body">
        <el-form-item prop="founderName">
          <label for="sample_name" class="el-form-item-label">
            <span class="xing">*</span>
            <span class="span-box">C1</span> 
            <span>创始人姓名</span>
            </label>
          <el-input v-model="form.founderName" placeholder="" :disabled="isActivityEnded" />
        </el-form-item>
        <el-form-item prop="founderAge">
          <label for="sample_name" class="el-form-item-label">
            <span class="xing">*</span>
            <span class="span-box">C2</span> 
            <span>创始人年龄</span>
            </label>
          <el-input v-model="form.founderAge" placeholder="" :disabled="isActivityEnded" />
        </el-form-item>
        <el-form-item prop="founderGender">
          <label for="sample_name" class="el-form-item-label">
            <span class="xing">*</span>
            <span class="span-box">C3</span> 
            <span>创始人性别</span>
            </label>
          <el-radio-group v-model="form.founderGender" :disabled="isActivityEnded">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="founderEntrepreneurship">
          <label for="sample_name" class="el-form-item-label">
            <span class="xing">*</span>
            <span class="span-box">C4</span> 
            <span>创始人目前是第几次创业</span>
            </label>
            <el-radio-group v-model="form.founderEntrepreneurship" :disabled="isActivityEnded">
            <el-radio label="第一次">第一次</el-radio>
            <el-radio label="第二次">第二次</el-radio>
            <el-radio label="三次以上">三次以上</el-radio>
          </el-radio-group>
         
        </el-form-item>

        
          </div></div>

         
        <div class="el-card box-card is-always-shadow">
        <div class="clearfix header_them">D、联系方式</div>
        <div class="clearfix el-card__body">
            <el-form-item prop="LinkerName">
          <label for="sample_name" class="el-form-item-label">
            <span class="xing">*</span>
            <span class="span-box">D1</span> 
            <span>联系人</span>
            </label>
          <el-input v-model="form.LinkerName" placeholder="" :disabled="isActivityEnded" />
        </el-form-item>
         <el-form-item prop="LinkerPhone">
          <label for="sample_name" class="el-form-item-label">
            <span class="xing">*</span>
            <span class="span-box">D2</span> 
            <span>手机/微信</span>
            </label>
          <el-input v-model="form.LinkerPhone" placeholder="" :disabled="isActivityEnded" />
        </el-form-item>
         <el-form-item prop="Linkerjoin">
          <label for="sample_name" class="el-form-item-label">
            
            <span class="span-box">D3</span> 
            <span>贵公司是否通过机构推荐参与活动</span>
            </label>
           <el-radio-group v-model="form.Linkerjoin" :disabled="isActivityEnded">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
          </div></div>
          <p style="font-size:12px;text-align:left;">备注：1.标*为必填项； 2.如要提交其他企业资料，请发送至 guoliqi@iceo.com.cn</p>
  <el-form-item>
          <!-- 按钮文字根据活动状态动态改变 -->
          <el-button type="primary" @click="submitForm" :loading="submitting" :disabled="isActivityEnded || submitting">
            {{ isActivityEnded ? '已结束' : '提交信息' }}
          </el-button>
        </el-form-item>
      </el-form>

      

    <div class="bottom">
      <img src="@/assets/futurestar2026/bottom.jpg" alt="底部" style="display: block; margin: 0px auto; width: 100%;">  
 
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollectView',
  data() {
    return {
      form: {
        companyShortName: '',
        companyFullName: '',
        foundingTime: '',
        headquarters: '',
        industry: '',
        productInMarket: '',
        revenueGrowth: '',
        valuation: '',
        financingRound: '',
        totalFinancing: '',
        investors: '',
        founderName: '',
        founderAge: '',
        founderGender: '',
        founderEntrepreneurship: '',
        founderEntrepreneur: '',
        LinkerName: '',
        LinkerPhone: '',
        Linkerjoin: ''
      },
      rules: {
        companyShortName: [
          { required: true, message: '数据不能为空', trigger: 'blur' }
        ],
        companyFullName: [
          { required: true, message: '数据不能为空', trigger: 'blur' }
        ],
        foundingTime: [
          { required: true, message: '数据不能为空', trigger: 'blur' }
        ],
        headquarters: [
          { required: true, message: '数据不能为空', trigger: 'blur' }
        ],
        industry: [
          { required: true, message: '数据不能为空', trigger: 'blur' }
        ],
        valuation: [
          { required: true, message: '数据不能为空', trigger: 'blur' }
        ],
        financingRound: [
          { required: true, message: '数据不能为空', trigger: 'blur' }
        ],
        totalFinancing: [
          { required: true, message: '数据不能为空', trigger: 'blur' }
        ],
        investors: [
          { required: true, message: '数据不能为空', trigger: 'blur' }
        ],
        founderName: [
          { required: true, message: '数据不能为空', trigger: 'blur' }
        ],
        founderAge: [
          { required: true, message: '数据不能为空', trigger: 'blur' }
        ],
        founderGender: [
          { required: true, message: '至少选择一项!', trigger: 'change' }
        ],
        founderEntrepreneurship: [
          { required: true, message: '至少选择一项!', trigger: 'change' }
        ],
        founderEntrepreneur: [
          { required: true, message: '至少选择一项!', trigger: 'change' }
        ],
        LinkerName: [
          { required: true, message: '数据不能为空', trigger: 'blur' }
        ],
        LinkerPhone: [
          { required: true, validator: this.validatePhone, trigger: 'blur' }
        ]
      },
      submitting: false,
      isActivityEnded: false,
      statusChecked: false
    };
  },
  mounted() {
    this.checkActivityStatus();
  },
  methods: {
    // 手机/微信号校验函数
    validatePhone(rule, value, callback) {
      if (!value) {
        callback(new Error('手机/微信不能为空'));
      } else if (!/^1[3-9]\d{9}$/.test(value) && !/^[a-zA-Z0-9_-]{5,20}$/.test(value)) {
        callback(new Error('请填写正确的手机号或微信号'));
      } else {
        callback();
      }
    },
    // 页面加载时主动检查活动状态（发送空POST请求）
    async checkActivityStatus() {
      try {
        const response = await fetch('/api/futurestar2026', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({})
        });
        if (!response.ok) {
          console.warn('活动状态检查失败', response.status);
          return;
        }
        const data = await response.json();
        console.log('活动状态检查结果：', data);
        if (data && (data.status === '0' || data.status === 0)) {
          this.isActivityEnded = true;
          this.$message.warning(data.msg || '本次活动已结束，无法提交报名信息');
        }
      } catch (error) {
        console.error('检查活动状态出错：', error);
      } finally {
        this.statusChecked = true;
      }
    },
    // 前端截止日期辅助判断（可选）
    checkDeadlineAndDisable() {
      const deadlineStr = '2026-06-15 18:00:00';
      const deadline = new Date(deadlineStr).getTime();
      const now = new Date().getTime();
      if (now > deadline) {
        this.isActivityEnded = true;
        this.$message.warning('征集活动已于2026年6月15日18:00结束，无法提交报名信息');
      }
    },
    submitForm() {
      if (this.isActivityEnded) {
        this.$message.error('活动已结束，无法提交报名信息');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postForm();
        } else {
          this.$message.error('请填写所有必填项后再提交');
        }
      });
    },
    async postForm() {
      if (this.submitting) return;
      this.submitting = true;
      try {
        const response = await fetch('/api/futurestar2026', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.form)
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (data && (data.status === '0' || data.status === 0)) {
          const errorMsg = data.msg || '本次活动已结束！';
          this.$message.error(errorMsg);
          this.isActivityEnded = true;
          return;
        }
        this.$message.success('信息提交成功！');
      } catch (error) {
        console.error('提交失败：', error);
        if (error instanceof SyntaxError) {
          this.$message.error('服务器返回了无效的响应，请检查网络或稍后重试');
        } else if (error.message && error.message.includes('Failed to fetch')) {
          this.$message.error('请求失败：请检查本地网络或代理服务器是否可用');
        } else {
          this.$message.error(error.message || '提交失败，请稍后重试');
        }
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.collect {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.banner img, .bottom img {
  width: 100%;
  height: auto;
}

.content {
  background: #f7f7f7;
  border-radius: 4px;
    min-height: 36px;
    padding: 25px 5%;
    width: 90%;
    text-align: justify;
}
.content ul {
    margin: 0;
    padding: 0;
    list-style: decimal;
    list-style-position: inside;
    line-height: 18px;
}
.content ul li{
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 14px;
    line-height: 18px;
}
.content p{
    text-align: justify;
    margin: 0;
    line-height: 24px;
    padding-left: 15px;
}
h2, h3 {
  color: #333;
  font-size: 16px;
}

ol {
  padding-left: 20px;
}

ul {
  padding-left: 20px;
}

p {
  margin: 10px 0;
}
.el-card{
    margin: 0px 6px 20px;
    border: none;
    background:none;
    color:#fff;
}
.el-card h3{
      font-size: 14px;
      font-weight: bold;
      margin: 10px 0px 4px;
      line-height: 18px;
}
.el-card span {
      line-height: 18px;
      display: block;
      margin: 0px;
       font-weight: normal;
}
.el-card.is-always-shadow{
      -webkit-box-shadow: 0 0 0 0 rgba(0,0,0,.1);

       box-shadow: 0 0 0 0 rgba(0,0,0,.1);
}
.header_them{
      padding: 18px 20px;
    text-align: center;
    font-weight: 700;
    color: #ea5306;
    font-size:18px;
}
.box-card{
    width: 100%;
    margin-bottom: 20px;
    margin: 20px auto 0px;
    background: #f7f7f7;
}
.el-card__body {
    padding: 20px;
}
.xing{
    color: #f56c6c;
    margin-right: 4px;
    width:12px;
    display: inline-block;
    float:left;
    font-size:16px;
}
.span-box{
      display: inline-block;
    width: 20px;
    height: 20px;
    background: #ec8923;
    text-align: center;
    line-height: 20px;
    border-radius: 20px;
    margin-right: 10px!important;
    font-size: 20px;
    padding: 0;
    color: #fff;
    float:left;
    font-size:12px;
}
.el-form-item-label{
  width: 100%;
    display: block;
    margin-bottom: 15px;
    font-weight: 700;
    color: #333;
    text-align: left;
    line-height: 20px;
    font-size: 14px!important;
    
}
.el-form-item >>> input {
    height: 40px!important;
    line-height: 40px;
    width: 100%;
}
.el-button--medium, .el-button--primary{
    width: 70%;
    height: 45px;
    display: block;
    margin: 30px auto;
    line-height: 45px;
    font-size: 20px;
    background-color: #ea5306;
    color: #fff;
    border: none;
    padding: 0;
}
.el-textarea__inner {
    display: block;
    resize: vertical;
    padding: 5px 15px;
    line-height: 1.5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    font-size: inherit;
    color: #606266;
    background-color: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
}
/* 活动结束提示条样式 */
.activity-ended-tip {
  background-color: #fef0e6;
  border-left: 4px solid #ea5306;
  padding: 12px 20px;
  margin: 20px 6px 0;
  border-radius: 4px;
  color: #ea5306;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.activity-ended-tip i {
  font-size: 18px;
}
</style>